import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import Loading from '../components/shared/Loading';
import ErrorPage from './Error';

import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { TrustArcConsentBanner, TrustArcProvider } from 'src/components/global/TrustArc/TrustArc';
import { GlobalStyles } from '../styles/globalStyles';
import { getGlobalTheme } from '../styles/theme';
import { MetaData } from './MetaData';
import PageTypeRenderer from './renderers/PageTypeRenderer';

const Page = ({ loading, nonce, pageData }) => {
  const location = useLocation();

  // Manually handle anchor links due to hydration errors breaking native browser behavior.
  // TODO: Remove this workaround once hydration errors are resolved and native anchor link behavior is restored.
  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));

      if (element) {
        requestAnimationFrame(() => {
          window.scrollTo({
            top: element.offsetTop,
            behavior: 'auto',
          });
        });
      }
    }
  }, [location.hash]);

  if (pageData && pageData.subject) {
    const theme = getGlobalTheme(pageData.subject.content.theme);

    return (
      <ThemeProvider theme={theme}>
        <TrustArcProvider>
          <TrustArcConsentBanner />
          <GlobalStyles theme={theme} />

          <div className="Page">
            {loading && <Loading loading={loading} />}
            <PageTypeRenderer page={pageData.subject} />
          </div>
          <MetaData nonce={nonce} page={pageData.subject.content} />
        </TrustArcProvider>
      </ThemeProvider>
    );
  }

  return <ErrorPage type="errorPageRender" />;
};

export default Page;

Page.propTypes = {
  loading: PropTypes.bool,
  nonce: PropTypes.string,
  pageData: PropTypes.object,
};
